import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

import axiosPrivate from 'config/axiosPrivate';
import ConfirmationModal from '../modal/ConfirmationModal';
import ErrorSuccesModal from '../modal/ErrorSuccesModal';
import { deleteAllTexts } from 'store/Admin/OrderDisplay';
import { deleteAllTexts as deleteAllTextsClient } from 'store/AdminClient/OrderDisplay';

const OrderTextDeleteButton = ({ orderTitle, orderId }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [confirmation, setConfirmation] = useState(false);
  const [confirmationMsg, setConfirmationMsg] = useState('');
  const [isSuccess, setIsSuccess] = useState(false);
  const [errorSuccess, setErrorSuccess] = useState(false);
  const [errorSuccessMsg, setErrorSuccessMsg] = useState('');

  const deleteTextes = () => {
    axiosPrivate
      .delete(`/project/${orderId}/deleteTexts`)
      .then(() => {
        setConfirmation(false);
        setErrorSuccessMsg(
          `${t('Les textes du projet ont été supprimés avec succès')} !`
        );
        setIsSuccess(true);
        setErrorSuccess(true);
        // Dispatch custom event to notify components that texts were deleted
        window.dispatchEvent(new CustomEvent('texts-deleted', { detail: { orderId } }));
        setTimeout(() => {
          dispatch(deleteAllTexts());
          dispatch(deleteAllTextsClient());
        }, 2000);
      })
      .catch((e) => {
        setIsSuccess(false);
        setConfirmation(false);
        if (e) {
          setErrorSuccessMsg(t("Oups....! Une erreur s'est produite"));
        }
        setErrorSuccess(true);
      });
  };
  return (
    <>
      <div
        className="bt-icon-trash"
        onClick={() => {
          setConfirmationMsg(
            `${t(
              'Voulez-vous vraiment supprimer les textes du projet'
            )} : ${orderTitle} `
          );
          setConfirmation(true);
        }}
      >
        <img src="Images/icon-trash.png" alt="icon-trash" />
      </div>
      <ConfirmationModal
        open={confirmation}
        message={confirmationMsg}
        handleClose={() => setConfirmation(false)}
        executeAction={deleteTextes}
      />
      <ErrorSuccesModal
        open={errorSuccess}
        message={errorSuccessMsg}
        handleClose={() => setErrorSuccess(false)}
        success={isSuccess}
        toggle={() => setErrorSuccess(!errorSuccess)}
      />
    </>
  );
};

export default OrderTextDeleteButton;
